var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3801 10.5596H18.6601C14.1872 10.5596 10.5601 14.1868 10.5601 18.6596V28.3796C10.5601 32.8524 14.1872 36.4796 18.6601 36.4796H28.3801C32.8529 36.4796 36.4801 32.8524 36.4801 28.3796V18.6596C36.4801 14.1868 32.8529 10.5596 28.3801 10.5596ZM34.0501 28.3796C34.0501 31.5062 31.5067 34.0496 28.3801 34.0496H18.6601C15.5335 34.0496 12.9901 31.5062 12.9901 28.3796V18.6596C12.9901 15.533 15.5335 12.9896 18.6601 12.9896H28.3801C31.5067 12.9896 34.0501 15.533 34.0501 18.6596V28.3796Z",
    fill: "#EA9E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.52 17.0396C19.9415 17.0396 17.04 19.941 17.04 23.5196C17.04 27.0981 19.9415 29.9996 23.52 29.9996C27.0986 29.9996 30 27.0981 30 23.5196C30 19.941 27.0986 17.0396 23.52 17.0396ZM23.52 27.5696C21.2877 27.5696 19.47 25.7519 19.47 23.5196C19.47 21.2856 21.2877 19.4696 23.52 19.4696C25.7524 19.4696 27.57 21.2856 27.57 23.5196C27.57 25.7519 25.7524 27.5696 23.52 27.5696Z",
    fill: "#EA9E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4861 17.4171C30.963 17.4171 31.3496 17.0305 31.3496 16.5536C31.3496 16.0768 30.963 15.6902 30.4861 15.6902C30.0093 15.6902 29.6227 16.0768 29.6227 16.5536C29.6227 17.0305 30.0093 17.4171 30.4861 17.4171Z",
    fill: "#EA9E1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.92,
    height: 25.92,
    fill: "white",
    transform: "translate(10.5601 10.5596)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.bf77d3c960fb730b15392afe6151515a.svg";
export { ForwardRef as ReactComponent };